export default "//static.tradera.net/touchweb/static/output/images/category-dvd-videos.20e79eeb.svg";